import { render } from "./AudioVideoConferencing.vue?vue&type=template&id=61308adf&ts=true"
import script from "./AudioVideoConferencing.ts?vue&type=script&lang=ts&external"
export * from "./AudioVideoConferencing.ts?vue&type=script&lang=ts&external"

import "./AudioVideoConferencing.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__